<div class="container payment-container">
    <div class="row d-block text-center pb-3">
      <h1 class="font-weight-bold section-title">Registro de pago</h1>
    </div>
  
    <!-- Sección Responsable y Detalle -->
    <div class="payment-section">
      <div class="mb-4">
        <h3 class="section-title">Responsable de la reserva</h3>
        <div class="reservation-header">
          <span>{{ reservation?.bookingPerson?.lastName }} {{ reservation?.bookingPerson?.firstName }}</span><br />
          {{ documentTypeLabel(reservation?.bookingPerson?.documentType) }} {{ reservation?.bookingPerson?.documentNumber }}
        </div>
      </div>
  
      <div class="mb-4">
        <h3 class="section-title">Detalle <span style="font-size: 0.9rem; font-weight: 400; color: #555;">(Precio por noche)</span></h3>
        <p><strong>Estadía: {{ reservation?.reservationDetails[0].numberOfNights }} noche(s)</strong></p>
  
        <div>
          <div *ngFor="let reservationDetail of reservation?.reservationDetails" class="room-detail">
            <span>{{ reservationDetail.room.name }} (Habitación N° {{ reservationDetail.room.number }})</span>
            <span>${{ reservationDetail.priceAtBooking | currency:'ARS':'symbol':'1.2-2':'es-AR' }}</span>
          </div>
        </div>
      </div>
  
      <div class="total-row">
        <div class="row-flex-center">
          <mat-icon>attach_money</mat-icon>
          Monto total:
        </div>
        <span>${{ reservation?.totalPrice | currency:'ARS':'symbol':'1.2-2':'es-AR' }}</span>
      </div>
    </div>
  
    <!-- Sección Pagos -->
    <div class="payment-section">
      <h3 class="section-title">Pagos</h3>
  
      <div *ngIf="reservation?.payments.length == 0" style="font-style: italic; color: #555;">
        No hay pagos registrados.
      </div>
  
      <table mat-table [dataSource]="reservation?.payments" class="styled-table mat-elevation-z1 w-100" *ngIf="reservation?.payments.length > 0">
        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let payment">{{ payment.paymentDate | date: 'dd-MM-yyyy' }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
  
        <ng-container matColumnDef="paymentMethod">
          <th mat-header-cell *matHeaderCellDef>Medio de pago</th>
          <td mat-cell *matCellDef="let payment">{{ paymentMethodEnum[payment.paymentMethod] }}</td>
          <td mat-footer-cell *matFooterCellDef style="text-align: right;"><strong>Total:</strong></td>
        </ng-container>
  
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Monto</th>
          <td mat-cell *matCellDef="let payment">{{ payment.amount | currency:'ARS':'symbol':'1.2-2':'es-AR' }}</td>
          <td mat-footer-cell *matFooterCellDef><strong>{{ getTotalAmount() | currency:'ARS':'symbol':'1.2-2':'es-AR' }}</strong></td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="paymentDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: paymentDisplayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="paymentDisplayedColumns" class="footer-row"></tr>
      </table>
    </div>
  
    <!-- Sección Registro de Pago -->
    <form [formGroup]="form" *ngIf="incompletePayment()" class="payment-section">
      <h3 class="section-title section-title-lg">Registrar un pago</h3>
  
      <div class="grid-container">
        <mat-form-field appearance="outline" class="full-width-field">
          <mat-label>Forma de Pago</mat-label>
          <mat-select formControlName="paymentMethod">
            <mat-option [value]="null">Seleccione...</mat-option>
            <mat-option *ngFor="let type of paymentMethods" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="outline" class="full-width-field">
          <mat-label>Monto</mat-label>
          <input matInput formControlName="amount" currencyInput />
          <mat-error *ngIf="form?.get('amount')?.hasError('maxAmount')">
            El monto no puede ser mayor a {{ form?.get('amount')?.getError('maxAmount')?.max }}
          </mat-error>
        </mat-form-field>
      </div>
  
      <div class="mt-3">
        <button [disabled]="form.invalid" (click)="registerPayment()">
          Confirmar Pago
        </button>
      </div>
    </form>
  </div>
  